import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postExecutionPhase1 } from '../Api'

export default generateApiAction({
  baseType: Types.EXECUTIONS.POST.P1,
  api: postExecutionPhase1,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/executions/PostPhase1Action.js